import { render, staticRenderFns } from "./CoreCategoryTable.vue?vue&type=template&id=6a2b4fc6&scoped=true"
import script from "./CoreCategoryTable.vue?vue&type=script&lang=js"
export * from "./CoreCategoryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2b4fc6",
  null
  
)

export default component.exports